import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import swal from "sweetalert";
import { API_SOISALAK, API_SOISALAK_UPLOAD } from "../utils";
import { logoutUser } from "actions/AuthAction";
import { useHistory } from "react-router-dom";

function TindakLanjutTemuan() {
  const [tindakLanjutList, setTindakLanjutList] = useState([]);
  const [modalTambah, setModalTambah] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [tindakLanjutToDelete, setTindakLanjutToDelete] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingTemuan, setLoadingTemuan] = useState(false);
  const [loadingTindakLanjut, setLoadingTindakLanjut] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingVerify, setLoadingVerify] = useState(false);
  const [modalVerifikasi, setModalVerifikasi] = useState(false);
  const [tindakLanjutToVerify, setTindakLanjutToVerify] = useState(null);

  // Form state
  const [idTemuan, setIdTemuan] = useState("");
  const [catatan, setCatatan] = useState("");
  const [tanggalTL, setTanggalTL] = useState("");
  const [idUser, setIdUser] = useState("");
  const [verifikasi, setVerifikasi] = useState("belum");
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [tahunTindakLanjut, setTahunTindakLanjut] = useState(
    new Date().getFullYear()
  );

  // Dropdown data
  const [temuanList, setTemuanList] = useState([]);
  const [users, setUsers] = useState([]);
  const [idDinas, setIdDinas] = useState(null);
  const [statusUser, setStatusUser] = useState(null);
  const [perangkatdaerah, setPerangkatdaerah] = useState(null);
  const history = useHistory();

  // Status verifikasi options
  const verifikasiOptions = [
    { value: "belum", label: "Belum" },
    { value: "proses", label: "Proses" },
    { value: "selesai", label: "Selesai" },
  ];

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setIdUser(JSON.parse(user).idUser);
      setIdDinas(JSON.parse(user).idDinas);
      setStatusUser(JSON.parse(user).status);
      setPerangkatdaerah(JSON.parse(user).perangkatdaerah);
    } else {
      logoutUser(history);
    }
  }, []);

  useEffect(() => {
    if (tahunTindakLanjut) {
      if (statusUser == 3) {
        ambilTindakLanjut();
        ambilTemuan();
      } else {
        ambilTindakLanjutDinas();
        ambilTemuanDinas();
      }
    }
  }, [tahunTindakLanjut, idDinas, statusUser]);

  const ambilTindakLanjut = async () => {
    setLoadingTindakLanjut(true);
    try {
      const res = await axios.get(
        `${API_SOISALAK}/tindak-lanjut/tahun/${tahunTindakLanjut}`
      );
      setTindakLanjutList(res.data.data || []);
    } catch (err) {
      swal("Gagal", "Gagal mengambil data tindak lanjut", "error");
    }
    setLoadingTindakLanjut(false);
  };

  const ambilTemuan = async () => {
    setLoadingTemuan(true);
    try {
      const res = await axios.get(
        `${API_SOISALAK}/tindak-lanjut/temuan-belum-tindaklanjuti/tahun/${tahunTindakLanjut}`
      );

      setTemuanList(res.data.data || []);
    } catch (err) {
      setTemuanList([]);
    }
    setLoadingTemuan(false);
  };

  const ambilTemuanDinas = async () => {
    setLoadingTemuan(true);
    try {
      const res = await axios.get(
        `${API_SOISALAK}/tindak-lanjut/temuan-belum-tindaklanjuti/dinas/${idDinas}/tahun/${tahunTindakLanjut}`
      );
      setTemuanList(res.data.data || []);
    } catch (err) {
      setTemuanList([]);
    }
    setLoadingTemuan(false);
  };

  const ambilTindakLanjutDinas = async () => {
    setLoadingTindakLanjut(true);
    try {
      const res = await axios.get(
        `${API_SOISALAK}/tindak-lanjut/dinas/${idDinas}/tahun/${tahunTindakLanjut}`
      );
      setTindakLanjutList(res.data.data || []);
    } catch (err) {
      setTindakLanjutList([]);
    }
    setLoadingTindakLanjut(false);
  };

  const resetForm = () => {
    setIdTemuan("");
    setCatatan("");
    setTanggalTL("");
    setVerifikasi("belum");
    setFile(null);
    setFileName("");
  };

  const handleTambah = async () => {
    if (!idTemuan || !catatan || !tanggalTL || !idUser) {
      swal(
        "Gagal",
        "Data idTemuan, catatan, tanggalTL, dan idUser harus diisi",
        "error"
      );
      return;
    }

    setLoadingSubmit(true);
    const formData = new FormData();
    formData.append("idTemuan", idTemuan);
    formData.append("catatan", catatan);
    formData.append("tanggalTL", tanggalTL);
    formData.append("idUser", idUser);
    if (file) {
      formData.append("file", file);
    }

    try {
      const res = await axios.post(`${API_SOISALAK}/tindak-lanjut`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.status === 201 || res.data.success) {
        swal("Sukses", "Tindak lanjut berhasil ditambahkan", "success");
        setModalTambah(false);
        resetForm();
        if (statusUser == 3) {
          ambilTindakLanjut();
          ambilTemuan();
        } else {
          ambilTindakLanjutDinas();
          ambilTemuanDinas();
        }
      } else {
        swal(
          "Gagal",
          res.data.message || "Gagal menambah tindak lanjut",
          "error"
        );
      }
    } catch (err) {
      swal(
        "Gagal",
        err.response?.data?.message || "Gagal menambah tindak lanjut",
        "error"
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  const openEditModal = (item) => {
    setEditData(item);
    setModalEdit(true);
  };

  const handleEdit = async () => {
    if (
      !editData.idTemuan ||
      !editData.catatan ||
      !editData.tanggalTL ||
      !idUser
    ) {
      swal(
        "Gagal",
        "Data idTemuan, catatan, tanggalTL, dan idUser harus diisi",
        "error"
      );
      return;
    }

    setLoadingEdit(true);
    const formData = new FormData();
    formData.append("idTemuan", editData.idTemuan);
    formData.append("catatan", editData.catatan);
    formData.append("tanggalTL", editData.tanggalTL);
    formData.append("idUser", idUser);
    if (file) {
      formData.append("file", file);
    }

    try {
      const res = await axios.put(
        `${API_SOISALAK}/tindak-lanjut/${editData.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res.status === 200 || res.data.success) {
        swal("Sukses", "Tindak lanjut berhasil diupdate", "success");
        setModalEdit(false);
        setEditData(null);
        setFile(null);
        if (statusUser == 3) {
          ambilTindakLanjut();
          ambilTemuan();
        } else {
          ambilTindakLanjutDinas();
          ambilTemuanDinas();
        }
      } else {
        swal(
          "Gagal",
          res.data.message || "Gagal mengupdate tindak lanjut",
          "error"
        );
      }
    } catch (err) {
      swal(
        "Gagal",
        err.response?.data?.message || "Gagal mengupdate tindak lanjut",
        "error"
      );
    } finally {
      setLoadingEdit(false);
    }
  };

  const handleDelete = async () => {
    if (!tindakLanjutToDelete) return;
    setLoadingDelete(true);
    try {
      const res = await axios.delete(
        `${API_SOISALAK}/tindak-lanjut/${tindakLanjutToDelete.id}`
      );
      if (res.status === 200) {
        swal("Sukses", "Tindak lanjut berhasil dihapus", "success");
        setShowDeleteConfirm(false);
        setTindakLanjutToDelete(null);
        if (statusUser == 3) {
          ambilTindakLanjut();
        } else {
          ambilTindakLanjutDinas();
        }
      } else {
        swal(
          "Gagal",
          res.data.message || "Gagal menghapus tindak lanjut",
          "error"
        );
      }
    } catch (err) {
      swal(
        "Gagal",
        err.response?.data?.message || "Gagal menghapus tindak lanjut",
        "error"
      );
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Validasi tipe file
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jpeg",
        "image/jpg",
        "image/png",
      ];
      if (!allowedTypes.includes(selectedFile.type)) {
        swal(
          "Gagal",
          "Hanya file PDF, DOC, DOCX, JPG, JPEG, PNG yang diperbolehkan!",
          "error"
        );
        e.target.value = null;
        setFileName("");
        return;
      }
      setFile(selectedFile);
      setFileName(selectedFile.name);
    } else {
      setFile(null);
      setFileName("");
    }
  };

  const handleVerifikasi = async () => {
    if (!tindakLanjutToVerify) return;

    setLoadingVerify(true);
    try {
      const res = await axios.patch(
        `${API_SOISALAK}/tindak-lanjut/verifikasi/${tindakLanjutToVerify.id}`,
        {
          verifikasi: "verified",
        }
      );
      if (res.status === 200 || res.data.success) {
        swal("Sukses", "Status verifikasi berhasil diupdate", "success");
        setModalVerifikasi(false);
        setTindakLanjutToVerify(null);
        if (statusUser == 3) {
          ambilTindakLanjut();
          ambilTemuan();
        } else {
          ambilTindakLanjutDinas();
          ambilTemuanDinas();
        }
      } else {
        swal(
          "Gagal",
          res.data.message || "Gagal mengupdate status verifikasi",
          "error"
        );
      }
    } catch (err) {
      swal(
        "Gagal",
        err.response?.data?.message || "Gagal mengupdate status verifikasi",
        "error"
      );
    } finally {
      setLoadingVerify(false);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .custom-spinner {
            display: inline-block;
            width: 16px;
            height: 16px;
            border: 2px solid #f3f3f3;
            border-top: 2px solid #007bff;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-right: 8px;
          }
        `}
      </style>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <CardTitle tag="h4">
                  Tindak Lanjut Temuan
                  {statusUser == 3
                    ? " Perangkat Daerah Kab. Rote Ndao"
                    : perangkatdaerah}
                </CardTitle>
                <Button
                  color="danger"
                  onClick={() => {
                    setModalTambah(true);
                    resetForm();
                  }}
                >
                  Tambah Tindak Lanjut
                </Button>
              </CardHeader>
              <CardBody>
                {/* Filter Tahun */}
                <Row style={{ marginBottom: 20 }}>
                  <Col md={3}>
                    <FormGroup>
                      <Label for="tahunFilter">
                        Filter Tahun Tindak Lanjut:
                      </Label>
                      <Input
                        type="select"
                        id="tahunFilter"
                        value={tahunTindakLanjut}
                        onChange={(e) => setTahunTindakLanjut(e.target.value)}
                        style={{ color: "black" }}
                      >
                        {Array.from({ length: 5 }, (_, i) => {
                          const year = new Date().getFullYear() + i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>No</th>
                      <th>Temuan</th>
                      <th>Dinas</th>
                      <th>Catatan</th>
                      <th>Tanggal Tindak Lanjut</th>
                      <th>Deadline Temuan</th>
                      <th>User</th>
                      <th>Status Verifikasi</th>
                      <th>File</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingTindakLanjut ? (
                      <tr>
                        <td
                          colSpan={10}
                          style={{ textAlign: "center", padding: "40px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                border: "4px solid #f3f3f3",
                                borderTop: "4px solid #007bff",
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite",
                              }}
                            />
                            <span style={{ color: "#666", fontSize: "14px" }}>
                              Memuat data tindak lanjut...
                            </span>
                          </div>
                        </td>
                      </tr>
                    ) : tindakLanjutList && tindakLanjutList.length > 0 ? (
                      tindakLanjutList.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{idx + 1}</td>
                          <td>{item.temuan}</td>
                          <td>{item.nama_dinas}</td>
                          <td>{item.catatan}</td>
                          <td>
                            {item.tanggalTL
                              ? new Date(item.tanggalTL).toLocaleDateString(
                                  "id-ID",
                                  {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                  }
                                )
                              : ""}
                          </td>
                          <td>
                            {item.deadline
                              ? new Date(item.deadline).toLocaleDateString(
                                  "id-ID",
                                  {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                  }
                                )
                              : ""}
                          </td>
                          <td>{item.nama_user}</td>
                          <td>
                            {item.verifikasi === null && statusUser == 1 ? (
                              <Button
                                size="sm"
                                color="warning"
                                onClick={() => {
                                  setTindakLanjutToVerify(item);
                                  setModalVerifikasi(true);
                                }}
                              >
                                Verifikasi
                              </Button>
                            ) : item.verifikasi === null ? (
                              <span className="badge badge-danger">
                                Belum Verifikasi
                              </span>
                            ) : (
                              <span className="badge badge-success">
                                Verified
                              </span>
                            )}
                          </td>
                          <td>
                            {item.file ? (
                              <a
                                href={`${API_SOISALAK_UPLOAD}${item.file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-info"
                              >
                                Lihat File
                              </a>
                            ) : (
                              "Tidak ada file"
                            )}
                          </td>
                          <td>
                            <Button
                              size="sm"
                              color="primary"
                              onClick={() => openEditModal(item)}
                              style={{ marginRight: 5 }}
                            >
                              Edit
                            </Button>
                            <Button
                              size="sm"
                              color="danger"
                              onClick={() => {
                                setTindakLanjutToDelete(item);
                                setShowDeleteConfirm(true);
                              }}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10}>Tidak ada data</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* Modal Tambah */}
        <Modal
          size="md"
          isOpen={modalTambah}
          toggle={() => setModalTambah(false)}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => setModalTambah(false)}>
            <div>
              <div className="headline-2">Tambah Tindak Lanjut</div>
            </div>
          </ModalHeader>
          <ModalBody>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Temuan
              </Label>
              <Col md={9}>
                <Input
                  type="select"
                  value={idTemuan}
                  onChange={(e) => setIdTemuan(e.target.value)}
                  style={{ color: "black" }}
                  disabled={loadingTemuan}
                >
                  <option value="">
                    {loadingTemuan
                      ? "Memuat data temuan..."
                      : "- Pilih Temuan -"}
                  </option>
                  {!loadingTemuan &&
                    temuanList.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.temuan} - {t.nama_dinas}
                      </option>
                    ))}
                </Input>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Catatan
              </Label>
              <Col md={9}>
                <Input
                  type="textarea"
                  value={catatan}
                  onChange={(e) => setCatatan(e.target.value)}
                  style={{ color: "black" }}
                  placeholder="Catatan tindak lanjut"
                  rows={3}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                Tanggal Tindak Lanjut
              </Label>
              <Col md={9}>
                <Input
                  type="date"
                  value={tanggalTL}
                  onChange={(e) => setTanggalTL(e.target.value)}
                  style={{ color: "black" }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label md={3} className="text-md-right">
                File (Opsional)
              </Label>
              <Col md={9}>
                <Input
                  type="file"
                  onChange={handleFileChange}
                  style={{ color: "black" }}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                />
                <small className="text-muted">
                  Format yang diperbolehkan: PDF, DOC, DOCX, JPG, JPEG, PNG
                </small>
                {fileName && (
                  <div className="mt-2">
                    <small className="text-info">
                      File yang dipilih: <strong>{fileName}</strong>
                    </small>
                  </div>
                )}
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <Button color="secondary" onClick={() => setModalTambah(false)}>
              Batal
            </Button>
            <Button
              color="primary"
              onClick={handleTambah}
              disabled={loadingSubmit}
            >
              {loadingSubmit ? (
                <>
                  <div className="custom-spinner" />
                  Menyimpan...
                </>
              ) : (
                "Simpan"
              )}
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Edit */}
        <Modal
          size="md"
          isOpen={modalEdit}
          toggle={() => setModalEdit(false)}
          contentClassName="p-0"
          modalClassName="modal-slide-in event-sidebar"
        >
          <ModalHeader toggle={() => setModalEdit(false)}>
            <div>
              <div className="headline-2">Edit Tindak Lanjut</div>
            </div>
          </ModalHeader>
          <ModalBody>
            {editData && (
              <>
                <FormGroup row>
                  <Label md={3} className="text-md-right">
                    Temuan
                  </Label>
                  <Col md={9}>
                    <Input
                      type="select"
                      value={editData.idTemuan}
                      onChange={(e) =>
                        setEditData({ ...editData, idTemuan: e.target.value })
                      }
                      style={{ color: "black" }}
                    >
                      <option value="">- Pilih Temuan -</option>
                      {temuanList.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.temuan} - {t.nama_dinas}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} className="text-md-right">
                    Catatan
                  </Label>
                  <Col md={9}>
                    <Input
                      type="textarea"
                      value={editData.catatan}
                      onChange={(e) =>
                        setEditData({ ...editData, catatan: e.target.value })
                      }
                      style={{ color: "black" }}
                      placeholder="Catatan tindak lanjut"
                      rows={3}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} className="text-md-right">
                    Tanggal Tindak Lanjut
                  </Label>
                  <Col md={9}>
                    <Input
                      type="date"
                      value={editData.tanggalTL}
                      onChange={(e) =>
                        setEditData({ ...editData, tanggalTL: e.target.value })
                      }
                      style={{ color: "black" }}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label md={3} className="text-md-right">
                    File Baru (Opsional)
                  </Label>
                  <Col md={9}>
                    <Input
                      type="file"
                      onChange={handleFileChange}
                      style={{ color: "black" }}
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    />
                    <small className="text-muted">
                      Format yang diperbolehkan: PDF, DOC, DOCX, JPG, JPEG, PNG
                    </small>
                    {fileName && (
                      <div className="mt-2">
                        <small className="text-info">
                          File yang dipilih: <strong>{fileName}</strong>
                        </small>
                      </div>
                    )}
                    {editData.file && !fileName && (
                      <div className="mt-2">
                        <small className="text-info">
                          File saat ini:{" "}
                          <a
                            href={`${API_SOISALAK}${editData.file}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Lihat File
                          </a>
                        </small>
                      </div>
                    )}
                  </Col>
                </FormGroup>
              </>
            )}
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center", paddingBottom: 10 }}>
            <Button color="secondary" onClick={() => setModalEdit(false)}>
              Batal
            </Button>
            <Button color="primary" onClick={handleEdit} disabled={loadingEdit}>
              {loadingEdit ? (
                <>
                  <div className="custom-spinner" />
                  Menyimpan...
                </>
              ) : (
                "Simpan"
              )}
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Delete */}
        <Modal
          isOpen={showDeleteConfirm}
          toggle={() => setShowDeleteConfirm(false)}
        >
          <ModalHeader toggle={() => setShowDeleteConfirm(false)}>
            Konfirmasi Hapus
          </ModalHeader>
          <ModalBody>
            Apakah Anda yakin ingin menghapus data tindak lanjut ini?
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setShowDeleteConfirm(false)}
            >
              Batal
            </Button>
            <Button
              color="danger"
              onClick={handleDelete}
              disabled={loadingDelete}
            >
              {loadingDelete ? (
                <>
                  <div className="custom-spinner" />
                  Menghapus...
                </>
              ) : (
                "Hapus"
              )}
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal Verifikasi */}
        <Modal
          isOpen={modalVerifikasi}
          toggle={() => setModalVerifikasi(false)}
        >
          <ModalHeader toggle={() => setModalVerifikasi(false)}>
            Verifikasi Tindak Lanjut
          </ModalHeader>
          <ModalBody>
            {tindakLanjutToVerify && (
              <div>
                <p>
                  <strong>Temuan:</strong> {tindakLanjutToVerify.temuan}
                </p>
                <p>
                  <strong>Catatan:</strong> {tindakLanjutToVerify.catatan}
                </p>
                <p>
                  <strong>Tanggal Tindak Lanjut:</strong>{" "}
                  {tindakLanjutToVerify.tanggalTL
                    ? new Date(
                        tindakLanjutToVerify.tanggalTL
                      ).toLocaleDateString("id-ID", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                    : ""}
                </p>
                <p>
                  <strong>User:</strong> {tindakLanjutToVerify.nama_user}
                </p>
                <hr />
                <p>Apakah Anda yakin ingin memverifikasi tindak lanjut ini?</p>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setModalVerifikasi(false)}>
              Batal
            </Button>
            <Button
              color="success"
              onClick={handleVerifikasi}
              disabled={loadingVerify}
            >
              {loadingVerify ? (
                <>
                  <div className="custom-spinner" />
                  Memverifikasi...
                </>
              ) : (
                "Verifikasi"
              )}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default TindakLanjutTemuan;
